import React from 'react';
import { Alert } from 'react-bootstrap';
import InfoIcon from "../images/i.svg?react";
import HTMLContent from './htmlContent';

export default function NeoInfo({ config, variant, className }) {
	let { info } = config;

	return (
		<Alert className={`queue-info${className ? ` ${className}` : ''}`} variant={variant}>
			{
				variant === 'warning' &&
				<div className="queue-info-icon-container">
					<InfoIcon className="i"/>
				</div>
			}
			<HTMLContent className="queue-info-content" content={info}/>
		</Alert>
	);
}
